import React, { Component } from 'react';
import { has, map } from 'lodash';
import Dropdown from '../common/Dropdown';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import io from 'socket.io-client';
import ToastMessage from '../common/ToastMessage';
import { BASE_URL } from '../../constants/api';

export default class DriverEmergencyHeader extends Component {
  constructor(props) {
    super(props);
    this.getGeoLocation = this.getGeoLocation.bind(this);
    this.showPosition = this.showPosition.bind(this);
    this.updateInfo = this.updateInfo.bind(this);
    this.checkAcceptFlag = this.checkAcceptFlag.bind(this);
  }

  componentWillMount() {
    if (localStorage.businessAccessToken) {
      window.socket = io.connect(BASE_URL, { query: 'token=' + localStorage.businessAccessToken });
    }
    this.checkAcceptFlag();
    this.updateInfo();
  }
  componentWillReceiveProps(nextProps) {
    //this.updateInfo();
    if (this.props.driveremergencyReducer.driverstatusupdate) {
      this.updateInfo();
      this.props.actions.driverStatusUpdateFlag(false);
      this.checkAcceptFlag();
    }
  }

  checkAcceptFlag() {
    if (
      this.props.driveremergencyReducer.driveremergencyinfo &&
      this.props.driveremergencyReducer.driverAcceptFlag == false
    ) {
      map(this.props.driveremergencyReducer.driveremergencyinfo.data, (info, index) => {
        console.log(info.jobdetailstatusId);
        if (info.jobdetailstatusId > 9) {
          this.props.actions.driverAcceptJob(true, info.garagejobquotes.userbookingrequest.customerId);
        }
      });
    }
  }

  updateInfo() {
    const that = this;
    const authData = JSON.parse(localStorage.getItem('businessAuthData'));
    if (authData.driverStatus != 3) {
      that.getGeoLocation();
      window.setInterval(
        function() {
          that.getGeoLocation();
        },
        60000
      );
      //that.getGeoLocation();
    }
  }
  getGeoLocation() {
    let x = document.getElementById('demo');
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    } else {
      alert('please turn on your GPRS for live track');
    }
  }
  showPosition(position) {
    this.props.actions.driverSetPositions(position.coords);
    /*window.MyVars = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
    };*/
    this.props.actions.getDriverEmergencyInfo(position);
    let acceptFlag = this.props.driveremergencyReducer;
    let locationInfo = {
      location: {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      },
      user: acceptFlag.driverAcceptFlag ? acceptFlag.clientId : ''
    };
    window.socket.emit('my-location', locationInfo, function() {});
    window.socket.on('my-location', function(data) {});
  }

  render() {
    const { authReducer, userReducer, driveremergencyReducer, commonReducer } = this.props;
    return (
      <div
        className={
          this.props.customClass
            ? `header-section navbar-fixed-top ${this.props.customClass}`
            : 'header-section navbar-fixed-top'
        }
      >
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-xs-7 col-sm-9 driver-Emergency-header-text container-fluid">
              <div
                className={
                  this.props.displayLogo == 'false'
                    ? 'logo-section-back logo-section col-xs-12'
                    : 'logo-section emergency-logo'
                }
              >
                {this.props.displayLogo == 'true' &&
                  <a
                    onClick={e => {
                      e.preventDefault();
                      this.props.router.push(`${appBasePath}/driver-dashboard`);
                    }}
                  >
                    <img src={`${imageBasePath}/logo.svg`} alt="" className="logo-img" />
                  </a>}
                {this.props.displayLogo == 'false' &&
                  <i
                    className="mdi  mdi-arrow-left"
                    onClick={e => {
                      e.preventDefault();
                      this.props.router.push(`${appBasePath}/driver-dashboard`);
                    }}
                  />}
              </div>
              <h5 className={this.props.displayLogo == 'false' ? ' header-display-back flow-name' : 'flow-name'}>
                {this.props.displayName}
              </h5>

            </div>
            <div className="col-xs-2 header-right">
              <ul className="list-unstyled">
                <li className="profile-header option-visible">
                  <Dropdown
                    actions={this.props.actions}
                    router={this.props.router}
                    driverInformation={driveremergencyReducer}
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        {commonReducer.toastMessage &&
          <ToastMessage
            actions={this.props.actions}
            type={commonReducer.toastType}
            title={commonReducer.toastType + '...'}
            text={commonReducer.toastMessage}
          />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DriverEmergency/DriverEmergencyHeader.jsx